import React from 'react'
import classes from "./Eighth.module.scss"
import img1 from "../../../assets/img/MainPage/8/1.png"

const Eighth = () => {
    return (
        <div className={[classes.fourth, ""].join(" ")}>
            <img src={img1} alt="" />
        </div>

    )
}

export default Eighth